<template>
	<div class="driver-licences" id="driver-type">
		<div class="grid">
			<div class="grid-item" v-for="(type, index) in typeData" :key="type.id">
				<a
					class="licence-item"
					:class="{ disabled: type.disabled, checked: index === typeIndex }"
                    @click="handleClick(index)"
					>{{ type.name }}</a
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'driving-type',
	props: {
		typeData: {
			type: Array,
			default: () => [
                { id: 0, name: '类型不限', value: '1', disabled: false ,v: 'all'},
				{ id: 4467, name: 'C1 小型汽车', value: '1', disabled: false ,v: 'c1 小型汽车'},
                { id: 4468, name: 'C2 小型自动挡汽车', value: '1', disabled: false ,v: 'c2 小型自动挡汽车'},
				{ id: 4469, name: 'C3 低数载货汽车', value: '2', disabled: true,v: 'c3 低数载货汽车'},
				{ id: 4470, name: 'A1 大型客车', value: '3', disabled: false, v: 'A1 大型客车'},
                { id: 4472, name: 'A3 城市公交车', value: '3', disabled: false, v: 'A3 城市公交车'},
				{ id: 4476, name: 'E 普通二轮摩托车', value: '4', disabled: false,v: 'E 普通二轮摩托车' },
				{ id: 4475, name: 'D 普通三轮摩托车', value: '5', disabled: true ,v: 'D 普通三轮摩托车'},
			],
		},
    },
    data: () => ({
		typeIndex: 0,
    }),
	methods: {
		handleClick(index) {
			if(this.typeData[index].disabled) return false;
			this.typeIndex = index;
            this.$emit('choose', this.typeData[index])
		},
	},
}
</script>

<style lang="less" scoped>
.driver-licences {
	padding: 15px 14px;
}
.licence-item {
	box-sizing: border-box;
	display: block;
	border: 1px solid rgba(153, 153, 153, 1);
	color: rgba(51, 51, 51, 1);
	border-radius: 6px;
	background: rgba(255, 255, 255, 1);
	font-size: 15px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	margin-bottom: 15px;
}
.licence-item.disabled {
	border: 1px solid rgba(204, 204, 204, 1);
	color: rgba(153, 153, 153, 1);
}
.licence-item.checked {
	border: 1px solid rgba(60, 67, 236, 1);
	color: rgba(60, 67, 236, 1);
}

.grid {
	font-size: 0;
	/* margin-left: 15px; */
}
.grid-item {
	box-sizing: border-box;
	display: inline-block;
	vertical-align: top;
	/* background-color: #000; */
	width: 50%;
	height: 50px;
	margin-bottom: 15px;
}
.grid-item:nth-child(odd) {
	padding-right: 7.5px; 
}
.grid-item:nth-child(even) {
	padding-left: 7.5px;
}
</style>
